import history from '../helpers/history';
import queryString from 'query-string';
import { getTranslationKey } from '../modules/utils/helpers';
import type { Notify } from '../typings/redux';

interface ErrorResponse {
  response?: {
    status: number;
  };
}

function generalError(notify: Notify | null): void {
  notify &&
    notify({
      title: getTranslationKey('error'),
      message: getTranslationKey('generalError'),
      status: 'error',
      position: 'top-center',
      dismissible: true,
      dismissAfter: 5000
    });
}

export function handleErrorWithRedirectIfNotAuth(
  e: ErrorResponse,
  notify: Notify | null = null
): void {
  const { loginAttempt } = queryString.parse(history.location.search);
  const notAllowedToRedirect = ['#/account', '#/subscription'];
  const notAllowedRoutes = notAllowedToRedirect.every(
    (item) => !window.location.hash.startsWith(item)
  );

  if (e.response) {
    switch (e.response.status) {
      case 401:
        notify &&
          notify({
            title: getTranslationKey('error'),
            message: getTranslationKey('sessionNotFoundError'),
            status: 'error',
            position: 'top-center',
            dismissible: true,
            dismissAfter: 5000
          });
        if (history.location.pathname !== '/logout' && loginAttempt !== '1') {
          setTimeout(() => history.push('/logout'), 1000);
        }
        break;
      case 402:
        notify &&
          notify({
            title: getTranslationKey('error'),
            message: getTranslationKey('subscription.paymentRequired'),
            status: 'error',
            position: 'top-center',
            dismissible: true,
            dismissAfter: 30000
          });
        break;
      case 423:
        notify &&
          notify({
            title: getTranslationKey('error'),
            message: getTranslationKey('subscription.chargebackFeeRequired'),
            status: 'error',
            position: 'top-center',
            dismissible: true,
            dismissAfter: 30000
          });
        if (window.location.hash && notAllowedRoutes) {
          history.push('/account');
        }
        break;
      default:
        generalError(notify);
    }
  } else {
    generalError(notify);
  }
}
